var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6545 0.546805C12.0371 0.937068 12.0309 1.56361 11.6406 1.94622L4.51262 8.93446L0.781229 5.53345C0.377304 5.16529 0.348312 4.53939 0.716472 4.13547C1.08463 3.73155 1.71053 3.70255 2.11446 4.07071L4.46307 6.21138L10.2551 0.532949C10.6453 0.150338 11.2719 0.156541 11.6545 0.546805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCheckWhite);
export default __webpack_public_path__ + "static/media/icn-check-white.3d69754b37396caf4cc197309802bc4e.svg";
export { ForwardRef as ReactComponent };